import React from 'react'
import Header from '../components/Header'

export default function HomePage() {
  return (
    <div>
        <Header />
    </div>
  )
}
